export default "__VITE_ASSET__8023d8c6__"